import React from 'react';
import './AppShell.css';
import { useRouteScrollRestoration } from '../hooks/useRouteScrollRestoration';

interface AppShellProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  disableScrollRestoration?: boolean;
  centerBody?: boolean;
  bodyScrollable?: boolean; // 是否让 body 可滚动，默认 true
}

const AppShell: React.FC<AppShellProps> = ({ header, footer, children, disableScrollRestoration, centerBody = false, bodyScrollable = true }) => {
  // Enable route-level scroll restoration for the AppShell body unless explicitly disabled
  useRouteScrollRestoration({
    containerSelector: '.app-shell-body',
    enabled: !disableScrollRestoration,
    storagePrefix: 'scroll@',
  });

  return (
    <div className="app-shell-root">
      <div className="app-shell-header">{header}</div>
      <div className={`app-shell-body ${centerBody ? 'centered' : ''} ${!bodyScrollable ? 'no-scroll' : ''}`}>{children}</div>
      <div className="app-shell-footer">{footer}</div>
    </div>
  );
};

export default AppShell;


